import { io } from "socket.io-client";
const socketServerURL = "https://backend-api.twingehealth.com";
export const socket = io(socketServerURL);
